import { createTamagui } from "tamagui";
import { themes } from "./themes.mjs";
import { defaultConfig } from "@tamagui/config/v5";
import { bodyFont, headingFont } from "./fonts.mjs";
import { animations } from "./animations.mjs";
const config = createTamagui({
  ...defaultConfig,
  animations,
  fonts: {
    body: bodyFont,
    heading: headingFont
  },
  settings: {
    ...defaultConfig.settings,
    onlyAllowShorthands: false,
    disableSSR: true
  },
  themes
});
var tamagui_config_default = config;
export { config, tamagui_config_default as default };
//# sourceMappingURL=tamagui.config.mjs.map
